import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useSuperAuth } from "../../context/SuperAuthContext";

export default function SuperLogin() {
  const { login } = useSuperAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const r = await login(email, password);
    setBusy(false);
    if (r.ok) {
      toast.success("Olá! Super Admin conectado");
      nav("/super/clientes");
    } else {
      toast.error(r.error || "Não foi possível entrar");
    }
  };

  return (
    <div className="min-h-screen bg-white text-zinc-900 flex items-center justify-center px-4 py-10 relative overflow-hidden">
      <div className="pointer-events-none absolute -top-32 -right-24 h-96 w-96 rounded-full bg-brand-100/60 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-32 -left-24 h-96 w-96 rounded-full bg-brand-50 blur-3xl" />

      <div className="w-full max-w-md relative">
        <div className="mb-8 flex flex-col items-center gap-3 text-center">
          <img src="/fila-gestao-logo.png?v=2" alt="FILA Gestão" className="h-20 w-20 object-contain drop-shadow" />
          <h1 className="font-display text-3xl font-semibold tracking-tight">FILA <span className="text-brand-500">Gestão</span></h1>
          <p className="text-[10px] uppercase tracking-[0.3em] text-zinc-500">Super Admin — Plataforma</p>
        </div>

        <form onSubmit={onSubmit} data-testid="super-login-form" className="rounded-2xl border border-brand-100 bg-white p-6 sm:p-8 shadow-lg shadow-brand-500/5">
          <div className="space-y-4">
            <div>
              <label className="mb-2 block text-xs font-medium uppercase tracking-wider text-zinc-500">E-mail</label>
              <input
                data-testid="super-login-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full rounded-lg border border-zinc-200 bg-white px-4 py-3 text-base outline-none transition-all focus:border-brand-500 focus:ring-2 focus:ring-brand-500/20"
                placeholder="super@filagestao.com.br"
                autoComplete="email"
              />
            </div>
            <div>
              <label className="mb-2 block text-xs font-medium uppercase tracking-wider text-zinc-500">Senha</label>
              <input
                data-testid="super-login-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full rounded-lg border border-zinc-200 bg-white px-4 py-3 text-base outline-none transition-all focus:border-brand-500 focus:ring-2 focus:ring-brand-500/20"
                autoComplete="current-password"
              />
            </div>
            <button
              data-testid="super-login-submit"
              type="submit"
              disabled={busy}
              className="w-full rounded-full bg-brand-500 py-3 text-sm font-semibold uppercase tracking-widest text-white shadow-sm shadow-brand-500/20 transition-all hover:bg-brand-600 hover:-translate-y-[1px] disabled:opacity-60"
            >
              {busy ? "Entrando…" : "Entrar"}
            </button>
          </div>
        </form>

        <p className="mt-6 text-center text-[11px] uppercase tracking-[0.25em] text-zinc-500">
          Área restrita à administração da plataforma
        </p>
      </div>
    </div>
  );
}
